import { createSlice } from "@reduxjs/toolkit";
import {
  fetchExpenseCategories,
  fetchExpenseCategoryById,
  addExpenseCategory,
  updateExpenseCategoryThunk,
  deleteExpenseCategoryThunk,
} from "./tournamentExpenseCategories.thunk";

const initialState = {
  categories: [],
  meta: {
    total: 0,
    total_pages: 1,
    page: 1,
    limit: 10,
  },
  loading: false,
  error: null,
  selectedCategory: null,
};

const tournamentExpenseCategoriesSlice = createSlice({
  name: "tournamentExpenseCategories",
  initialState,

  reducers: {
    setSelectedCategory: (state, action) => {
      state.selectedCategory = action.payload;
    },

    clearSelectedCategory: (state) => {
      state.selectedCategory = null;
    },
  },

  extraReducers: (builder) => {
    builder

      /* ============================================================
         FETCH ALL
      ============================================================ */

      .addCase(fetchExpenseCategories.pending, (state) => {
        state.loading = true;
        state.error = null;
      })

      .addCase(fetchExpenseCategories.fulfilled, (state, action) => {
        state.loading = false;

        const payload = action.payload;

        let categories = [];

        if (Array.isArray(payload?.data)) {
          categories = payload.data;
        } else if (Array.isArray(payload?.data?.data)) {
          categories = payload.data.data;
        }

        state.categories = categories;

        state.meta = payload?.meta || {
          total: categories.length,
          total_pages: 1,
          page: 1,
          limit: 10,
        };
      })

      .addCase(fetchExpenseCategories.rejected, (state, action) => {
        state.loading = false;
        state.error =
          action.payload || "Failed to fetch expense categories";
      })

      /* ============================================================
         FETCH SINGLE
      ============================================================ */

      .addCase(fetchExpenseCategoryById.pending, (state) => {
        state.loading = true;
      })

      .addCase(fetchExpenseCategoryById.fulfilled, (state, action) => {
        state.loading = false;
        state.selectedCategory = action.payload;
      })

      .addCase(fetchExpenseCategoryById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      /* ============================================================
         ADD
      ============================================================ */

      .addCase(addExpenseCategory.pending, (state) => {
        state.loading = true;
      })

      .addCase(addExpenseCategory.fulfilled, (state) => {
        state.loading = false;
        // Refetch handled in component
      })

      .addCase(addExpenseCategory.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      /* ============================================================
         UPDATE
      ============================================================ */

      .addCase(updateExpenseCategoryThunk.pending, (state) => {
        state.loading = true;
      })

      .addCase(updateExpenseCategoryThunk.fulfilled, (state, action) => {
        state.loading = false;

        const updated = action.payload?.data;

        if (!updated) return;

        const id =
          action.payload.id ||
          updated.id;

        const index = state.categories.findIndex(
          (category) => category.id === id
        );

        if (index !== -1) {
          state.categories[index] = {
            ...state.categories[index],
            ...updated,
          };
        }

        if (
          state.selectedCategory &&
          state.selectedCategory.id === id
        ) {
          state.selectedCategory = {
            ...state.selectedCategory,
            ...updated,
          };
        }
      })

      .addCase(updateExpenseCategoryThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      /* ============================================================
         DELETE
      ============================================================ */

      .addCase(deleteExpenseCategoryThunk.pending, (state) => {
        state.loading = true;
      })

      .addCase(deleteExpenseCategoryThunk.fulfilled, (state, action) => {
        state.loading = false;

        const id = action.payload;

        state.categories = state.categories.filter(
          (category) => category.id !== id
        );

        if (
          state.selectedCategory &&
          state.selectedCategory.id === id
        ) {
          state.selectedCategory = null;
        }
      })

      .addCase(deleteExpenseCategoryThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const {
  setSelectedCategory,
  clearSelectedCategory,
} = tournamentExpenseCategoriesSlice.actions;

export default tournamentExpenseCategoriesSlice.reducer;